import {
  Box,
  Table,
  TableRow,
  TableCell,
  TableHead,
  Typography,
} from "@mui/material";
import { CardCore } from "src/Pages/components/CardCore/CardCore";
import ReportIcon from "@mui/icons-material/Report";
import { IFlowCampaign } from "src/Contexts/Campaign/CampaignContextTypes";
import {
  colorCampaignFlowsLogsStatus,
  colorCampaignFlowsLogsStatusIcon,
} from "../HelpersObjs/HelpersObjs";
import { handleFormatDateToPhraseSignatureWithHour } from "src/shared/Utils/FormatDate/FormatDateToPhraseSignature";
import { formatString } from "@format-string/core";
interface IListHistoryCampaignLeads {
  data: IFlowCampaign;
}

export const ListHistoryCampaignLeads = ({
  data,
}: IListHistoryCampaignLeads) => {
  return (
    <CardCore sxStyle={{ m: 0, overflowX: "auto" }}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ minWidth: 200 }}>Nome</TableCell>
            <TableCell>Status</TableCell>
            <TableCell align="left" sx={{ minWidth: 145 }}>
              Data Programada
            </TableCell>
            <TableCell align="left" sx={{ minWidth: 145 }}>
              Data execução
            </TableCell>
            <TableCell align="center">Tentativas</TableCell>
            <TableCell align="center">Erro</TableCell>
          </TableRow>
        </TableHead>

        {data.CampaignFlowLogs.map((item) => {
          return (
            <TableRow
              key={item.id}
              sx={{
                padding: "4px 12px",
              }}
            >
              <TableCell>
                <Box>
                  <Typography>{item.leads.name}</Typography>
                  <Typography color="text.secondary" fontSize="13px">
                    {formatString({
                      type: "phone",
                      value: item.leads.whats,
                    })}
                  </Typography>
                </Box>
              </TableCell>

              <TableCell align="left">
                <Box
                  sx={{
                    border: "1px solid #bdbdbd",
                    padding: "4px 12px",
                    borderRadius: "16px",
                    width: "fit-content",

                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Typography sx={{ mr: "12px" }}>
                    {colorCampaignFlowsLogsStatus[item.status].text}
                  </Typography>
                  <Box
                    sx={{
                      color:
                        colorCampaignFlowsLogsStatusIcon[item.status].color,
                      pt: "3px",
                    }}
                  >
                    {colorCampaignFlowsLogsStatusIcon[item.status].icon}
                  </Box>
                </Box>
              </TableCell>

              <TableCell align="left">
                <Typography>
                  {handleFormatDateToPhraseSignatureWithHour(data.dateFull)}
                </Typography>
              </TableCell>

              <TableCell align="left">
                <Typography>
                  {item.status !== "PENDING" &&
                    handleFormatDateToPhraseSignatureWithHour(
                      item.dateExecution
                    )}
                </Typography>
              </TableCell>

              <TableCell align="center">
                <Typography>{item.retryCount}</Typography>
              </TableCell>

              <TableCell align="center">
                <Typography>
                  {item.status === "ERROR" && (
                    <ReportIcon fontSize="small" color="error" />
                  )}
                </Typography>
              </TableCell>
            </TableRow>
          );
        })}
      </Table>
    </CardCore>
  );
};
